import base from '../base'
import { postJsonRequest } from '@utils/request'

const cloud = `prescription/${base.appCode}`

/**
 * 扫码手写签名相关接口
 *
 * 业务流程：
 *  1. PC 端调用 createSignSession 创建一次性签名会话，得到 sessionId + signToken
 *  2. PC 端用 sessionId / signToken 生成二维码，手机扫码打开 H5 签名页
 *  3. 手机端调用 getSignSession 校验会话有效性（并把状态置为已扫码）
 *  4. 手机端签名后将图片上传 OSS，得到图片地址，调用 submitSign 回传
 *  5. PC 端轮询 getSignResult，拿到 signUrl 后写入表单
 *
 * 安全说明：
 *  - createSignSession / getSignResult 走正常登录态（带 token）
 *  - getSignSession / submitSign 面向无登录态的手机页，依靠 signToken 做一次性校验
 */
const ELECTRONICSIGN = {

  // 【PC-需登录】创建签名会话
  // 入参: { signType: 'deployment' | 'send' }
  // 返回: { sessionId, signToken, expireSeconds }
  createSignSession(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/electronicSign/manage/v1/createSession`, params)
  },

  // 【PC-需登录】轮询签名结果
  // 入参: { sessionId }
  // 返回: { status: 'WAITING'|'SCANNED'|'SIGNED'|'EXPIRED', signUrl }
  getSignResult(params = {}) {
    params.appCode = base.appCode
    // loading=false，避免轮询时反复出现全屏 loading
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/electronicSign/manage/v1/getResult`, params, '', false)
  },

  // 【手机-免登录】校验会话并标记为已扫码
  // 入参: { sessionId, signToken }
  // 返回: { status, signType, expireSeconds }
  getSignSession(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/electronicSign/h5/v1/getSession`, params)
  },

  // 【手机-免登录】回传签名图片地址
  // 入参: { sessionId, signToken, signUrl }
  // 返回: { success: true }
  submitSign(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/electronicSign/h5/v1/submit`, params)
  }
}

export default ELECTRONICSIGN



// WEBPACK FOOTER //
// ./src/api/modules/electronicSign.js